import React, { Component } from 'react'
import { Button, NavItem, Nav, NavLink } from 'reactstrap';

import '../App.css';
import LoggedContext from '../BusinessObjects/LoggedContext'
import EsaedroHistoryItem from '../Models/EsaedroHistoryItem';


interface IEsaedroMenuHistoryProps {
  name:string;
  className:string;
  onClick?(menuItemId: any): void;
  items: EsaedroHistoryItem[]
}

export default class EsaedroMenuHistory extends Component<IEsaedroMenuHistoryProps> {
  static contextType = LoggedContext

  incrementalKey = 0
  
  constructor(props: IEsaedroMenuHistoryProps){
      super(props);

      this.historyMenuItemSelected = this.historyMenuItemSelected.bind(this)
  }

  historyMenuItemSelected(e: any) {
    if (this.props.onClick!=undefined) {
      this.props.onClick(e.target.value)
    }
  }

  render() {
    
   this.incrementalKey++
   if (!this.props.items.length)
    {
      return (
          <Nav>
            <NavItem className={this.props.className?this.props.className:"form-group"} key={"nav_"+this.incrementalKey}>
              <NavLink disabled key={this.incrementalKey}>Home: </NavLink>
            </NavItem>
          </Nav>
        
      )
    }
    else
    {
      const historyBar = (this.props.items!==undefined? this.props.items.map((menuVoice: any, i , voices) => {
        if (voices.length-1 === i)
          return (
            <NavItem className={this.props.className?this.props.className:"form-group"} key={"nav_"+i}>
              <NavLink disabled key={i}>{menuVoice.selectedItem.Description}</NavLink>
            </NavItem>
          )
        else return (
            <NavItem className={this.props.className} key={"nav_"+i}>
              <Button color="link" value={menuVoice.selectedItem.Id} onClick={this.historyMenuItemSelected} key={i}> {menuVoice.selectedItem.Description} </Button><span> / </span>
            </NavItem>
          )  
      }
      ):'Nessuno storico...');

      return (
        <Nav>
          {historyBar}  
        </Nav>   
      )
    }
  }
}
  